import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from './AuthContext'

// Wrap a route element in <RequireAuth> to gate it. Unauthenticated callers
// get bounced to /login with the attempted URL in location.state.from so
// the Login page can return them after success.
export function RequireAuth({ children }: { children: ReactNode }) {
  const { accessToken } = useAuth()
  const location = useLocation()

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  return <>{children}</>
}
